import { Injectable } from '@angular/core';

export type RouteParams = { [key: string]: any };

// TODO(Ride WSS): Refactor this out in favor of using the angular router
@Injectable({
  providedIn: 'root'
})
export class RouteParamsService {
  private routeParams: { [key: string]: RouteParams } = {};

  constructor() {}

  setRouteParams(route: string, params: RouteParams) {
    this.routeParams[route] = params;
  }

  getRouteParams(route: string): RouteParams {
    return this.routeParams[route];
  }

  // When do I clear these?
  clearRouteParams(route: string) {
    delete this.routeParams[route];
  }
}
